import {isWebViewRequest} from '~/src/utilities/helpers/webview';
import {getFeatureConfig} from '~/src/utilities/helpers/feature';

const getInitialSettings = (ctx) => {
    const settings = {};

    if (!process.browser) {
        settings.isWebView = isWebViewRequest(ctx);
        settings.feature = getFeatureConfig(ctx);
        settings.isFromLegacy = ctx.query.legacy === 'true';
    }

    return settings;
};

export {getInitialSettings};
